import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustSignals from "@/components/TrustSignals";
import Services from "@/components/Services";
import LatestNews from "@/components/LatestNews";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <>
      <SeoHead
        title="AI-labbet | We create value with responsible AI"
        description="AI-labbet provides AI strategy, governance, and skilling services. We help organizations create business value through responsible AI."
        path="/"
      />
      
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <Hero />
          <TrustSignals />
          <Services />
          <LatestNews />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};
export default Index;